import React from "react";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#0F5C69] text-white py-24 md:py-28 overflow-hidden"
    >
      {/* Subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.28em] font-bold text-white/70">
              [ 05 ] — Kontakt
            </div>
            <h2 className="font-display text-[clamp(2.5rem,6vw,5.5rem)] font-black tracking-[-0.03em] leading-[0.98] mt-6">
              Připraveni<br />
              <span className="italic font-light">na reprezentativní</span><br />
              čistotu?
            </h2>
            <p className="mt-8 max-w-lg text-white/80 leading-relaxed">
              Ozvěte se — do 24 hodin se vám ozve náš manažer, domluvíme
              nezávaznou prohlídku a připravíme kalkulaci šitou na míru.
            </p>

            <div className="mt-12 flex flex-wrap gap-4">
              <a
                href="tel:+420775601254"
                data-testid="contact-cta-phone"
                onClick={() =>
                  trackEvent("form_submit_contact", {
                    channel: "phone",
                    location: "contact_section_cta",
                  })
                }
                className="group inline-flex items-center gap-3 bg-white text-[#0F5C69] px-7 h-14 font-semibold tracking-tight hover:bg-[#E6F2F4] transition-colors"
              >
                <Phone size={18} strokeWidth={2.5} />
                <span className="tabular-nums">+420 775 601 254</span>
                <ArrowUpRight
                  size={16}
                  strokeWidth={2.5}
                  className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </a>
              <a
                href="mailto:info@sanvioro.cz"
                data-testid="contact-cta-email"
                onClick={() =>
                  trackEvent("form_submit_contact", {
                    channel: "email",
                    location: "contact_section_cta",
                  })
                }
                className="inline-flex items-center gap-3 border border-white/40 text-white px-7 h-14 font-semibold tracking-tight hover:bg-white/10 transition-colors"
              >
                <Mail size={18} strokeWidth={2.5} />
                info@sanvioro.cz
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pl-8 lg:border-l border-white/20 space-y-10 mt-4">
            <div>
              <div className="flex items-center gap-3 text-white/60 text-xs uppercase tracking-[0.28em] font-bold">
                <Phone size={14} strokeWidth={2.5} />
                Telefon
              </div>
              <a
                href="tel:+420775601254"
                data-testid="contact-phone"
                onClick={() =>
                  trackEvent("form_submit_contact", {
                    channel: "phone",
                    location: "contact_section_detail",
                  })
                }
                className="block font-display text-3xl md:text-4xl font-bold tabular-nums mt-3 hover:text-white/70 transition-colors"
              >
                +420 775 601 254
              </a>
            </div>
            <div>
              <div className="flex items-center gap-3 text-white/60 text-xs uppercase tracking-[0.28em] font-bold">
                <Mail size={14} strokeWidth={2.5} />
                E-mail
              </div>
              <a
                href="mailto:info@sanvioro.cz"
                data-testid="contact-email"
                onClick={() =>
                  trackEvent("form_submit_contact", {
                    channel: "email",
                    location: "contact_section_detail",
                  })
                }
                className="block font-display text-2xl md:text-3xl font-bold mt-3 hover:text-white/70 transition-colors break-all"
              >
                info@sanvioro.cz
              </a>
            </div>
            <div>
              <div className="flex items-center gap-3 text-white/60 text-xs uppercase tracking-[0.28em] font-bold">
                <MapPin size={14} strokeWidth={2.5} />
                Působnost
              </div>
              <div
                data-testid="contact-location"
                className="font-display text-2xl md:text-3xl font-bold mt-3"
              >
                Brno, ČR
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
